import { render, staticRenderFns } from "./inventoryofmaterialDetails.vue?vue&type=template&id=f37da38c&scoped=true&"
import script from "./inventoryofmaterialDetails.vue?vue&type=script&lang=js&"
export * from "./inventoryofmaterialDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f37da38c",
  null
  
)

export default component.exports